import { compose, mapProps } from 'recompose';
import { connectUserDetail } from '../../Auth/UserDetailManager';

// eslint-disable-next-line
export const withUserEmail = compose(
  connectUserDetail,
  mapProps(({
    userDetail: { email },
    ...props
  }) => ({
    email,
    ...props
  }))
);



// WEBPACK FOOTER //
// ./src/Common/Providers/WithUserEmail.js